import React from "react";
import Layout from "../components/Layout/Layout";
import "../styles/breadcrumb.css";

const Breadcrumb = () => {
    return (
        <nav className="breadcrumb-container">
            <ul className="breadcrumb">
                <li><a href="/">Home</a></li>
                <li><a href="/releases">Release</a></li>
                <li className="active">Release Notes 1.0</li>
            </ul>
        </nav>
    );
};


const ReleaseNotes = () => {
    return (    
        <Layout>
            <div className="release-notes-container">
                {/* Add Breadcrumb Component */}
                <Breadcrumb />

                <header className="release-header">
                    <h1 className="marginBottom10px">Release Notes</h1>
                    <h2>Finnkoda Web Application v2.0</h2>
                    <p><strong>Release Date:</strong> June 09, 2025</p>
                </header>
                <section className="features-section">
                    <h3>UI/UI Updates</h3>
                    <ul className="custom-list">
                        <li >
                            <strong>Updated UI Theme</strong>
                            <p className="marginTop5px"> Introduced a modern, cohesive color palette to refresh the look and feel.</p>
                            <p>Enhanced visual consistency and improved contrast for better readability.</p>
                        </li>
                        <li>
                            <strong>Improved Graphics & Visuals</strong>
                            <p className="marginTop5px">
                                Updated icons, charts, and graphic elements for a sharper, cleaner presentation.
                            </p>
                            <p>Enhanced data visualization components for a more intuitive user experience.</p>
                        </li>
                        <li>
                            <strong>Usability Enhancements</strong>
                            <p className="marginTop5px">
                                Refined layout and navigation to make key actions more accessible.
                            </p>
                            <p>Streamlined user flows for smoother interactions and faster task completion.</p>
                        </li>
                    </ul>
                </section>

                <section className="important-notes-section">
                    <h3>Important Notes</h3>
                    <ul className="custom-list">
                        <li><strong>Data Backup Advisory</strong> - We strongly recommend backing up your financial data before making any updates to avoid accidental data loss</li>
                        <li><strong>Feedback & Support</strong> - Your feedback is invaluable to us! If you encounter any issues or have suggestions, please reach out to us at <a href="mailto:contact@finnkoda.com">contact@finnkoda.com</a>.</li>
                    </ul>
                </section>

                <footer className="release-footer">
                    <p>Thank you for choosing Finnkoda as your trusted financial partner!</p>
                </footer>


            </div>
        </Layout>
    );
};
           
export default ReleaseNotes;

                // Introduced a modern, cohesive color palette to refresh the look and feel.
                // Enhanced visual consistency and improved contrast for better readability.

                // Improved Graphics & Visuals

                // Updated icons, charts, and graphic elements for a sharper, cleaner presentation.
                // Enhanced data visualization components for a more intuitive user experience.

                // Usability Enhancements

                // Refined layout and navigation to make key actions more accessible.
                // Streamlined user flows for smoother interactions and faster task completion.